import {
  FormControlLabel,
  Switch,
  SxProps,
  Theme,
  FormHelperText,
  FormControl,
} from '@mui/material';

export type ErrorStatus =
  | { tag: 'Submited'; errors: string[] }
  | { tag: 'Not submitted' };

type SwitchButtonProps = {
  defaultValue?: boolean | null;
  onChange: (checked: boolean) => void;
  value?: number;
  label: string;
  name: string;
  placeholder?: string;
  errors?: ErrorStatus;
  required?: boolean;
  sx?: SxProps<Theme>;
  multiline?: boolean;
  autoComplete?: 'false' | 'true';
  checked: boolean;
};

/**
 * Switch Button
 *
 * A controlled switch button component based on MUI's `Switch`.
 * It handles value changes via the `onChange` callback and displays validation errors
 */

function SwitchButton({
  label,
  onChange,
  name,
  checked,
  errors,
}: SwitchButtonProps) {
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    onChange(checked);
  };

  const hasErrors = errors?.tag === 'Submited' && errors.errors.length > 0;

  return (
    <FormControl error={hasErrors} sx={{ display: 'block' }}>
      <FormControlLabel
        control={
          <Switch checked={checked} onChange={handleChange} name={name} />
        }
        label={label}
      />
      {hasErrors && <FormHelperText>{errors.errors.join(', ')}</FormHelperText>}
    </FormControl>
  );
}

export default SwitchButton;
